import '@/app/app.css';
import './content.css';

import '@/app/app';

window.addEventListener('DOMContentLoaded', () => {
	console.log('content');
});
